import React from "react";
import styles from "../styles/Footer.module.css";
import {
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaMapMarkerAlt,
} from "react-icons/fa";
import logo from "../images/logo.jpg";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        {/* LEFT */}
        <div className={styles.footerLeft}>
          <a href="/">
            <img src={logo} alt="Home" className={styles.logoImg} />
          </a>
          <p className={styles.description}>
            Contactați-ne pentru închirierea auto în Bălți prin intermediul
            rețelelor sociale, telefon, Viber, Facebook sau Telegram.
          </p>
        </div>

        {/* LINKS */}
        <div className={styles.footerCenter}>
          <h4>Linkuri Utile</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/conditii">TERMENI ȘI CONDIȚII</a></li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className={styles.footerRight}>
          <h4>OFICIUL CENTRAL</h4>

          <p className={styles.contactInfo}>
            <a
              className={styles.contactLink}
              href="https://www.google.com/maps/search/?api=1&query=Balti+str.+Kiev+48A"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaMapMarkerAlt /> Bălți, str. Kiev 48A
            </a>
          </p>

          <p className={styles.contactInfo}>
            <FaInstagram />
            <a
              className={styles.contactLink}
              href="https://www.instagram.com/supreme__rentals/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Supreme Rentals
            </a>
          </p>

          <p className={styles.contactInfo}>
            <FaFacebook />
            <a
              className={styles.contactLink}
              href="https://www.facebook.com/ChirieAutoBALTI"
              target="_blank"
              rel="noopener noreferrer"
            >
              Supreme Rentals
            </a>
          </p>

          <p className={styles.contactInfo}>
            <FaEnvelope />
            <a
              className={styles.contactLink}
              href="mailto:supremerentals.srl@gmail.com"
            >
              supremerentals.srl@gmail.com
            </a>
          </p>
        </div>
      </div>

      {/*<div className={styles.footerBottom}>*/}
      {/*  <p>*/}
      {/*      © {new Date().getFullYear()} Supreme Rentals · Chișinău, Moldova*/}
      {/*  </p>*/}
      {/*</div>*/}
        <footer className="srCars_footer">
          © {new Date().getFullYear()} Supreme Rentals · Chișinău, Moldova
        </footer>
    </footer>
  );
};

export default Footer;